module.exports = __webpack_public_path__ + "static/media/icon-report.5ad520a0.svg";